module.exports = __webpack_public_path__ + "static/img/logo-108x108.7a3dce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-108x108.png
// module id = zUAT
// module chunks = 1